import { i18n } from '@/plugins/i18n'

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'title',
        title: i18n.t('reports.users.fullname'),
        sortable: true,
        width: 120,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
        template: (row) => {
            return '<a href="/users/' + row.id + '/details">'+row.title+'</a>'
        },
    },
    {
        field: 'user_level',
        title: i18n.t('reports.users.user_level'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('reports.users.created_at'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'last_update',
        title: i18n.t('reports.users.last_update'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'last_ip_login',
        title: i18n.t('reports.users.last_ip_login'),
        sortable: false,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'total_transactions',
        sortable: true,
        title: i18n.t('reports.gateways.total_transactions'),
        textAlign: 'center',
        width: 70
    },
    {
        field: 'total_wage',
        sortable: true,
        title:i18n.t('reports.gateways.total_wage'),
        textAlign: 'center',
        width: 80
    },
    {
        field: 'unsettled_balance',
        sortable: true,
        title:i18n.t('reports.gateways.unsettled_balance'),
        textAlign: 'center',
        width: 80
    },
]